import styled from "@emotion/styled";
import { Button } from "react-bootstrap";
import { IStyledComponentProps } from "../../../theme/theme.types";

const PageHeading = styled.div<IStyledComponentProps>`
  &.page-heading {
    border-bottom: 4px solid ${(props) => props.theme.colors?.cta.primary};
    color: ${(props) => props.theme.colors?.cta.primary};
    font-size: 36px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
`;

const HowToVideoLinkButton = styled(Button)<IStyledComponentProps>`
  &.howto-link-button {
    appearance: none;
    background-color: transparent;
    border: 0 none;
    cursor: pointer;
    color: ${(props) => props.theme?.colors.brand.primary};
    text-decoration: none;
    font-size: 14px;
    padding-right: 0;
    vertical-align: bottom;
    align-self: flex-end;
  }
`;

export default {
  PageHeading,
  HowToVideoLinkButton,
};
